/**
 * Product page: quantity stepper, live total on the add button, ?variant= in the URL and the
 * image thumbnails. Adding to the cart is cart.js's job (the form carries data-add-to-cart).
 */

/** Same output as Liquid's money filter for the shop's money format, e.g. "€{{amount_with_comma_separator}}". */
function formatMoney(cents, format) {
  const [whole, decimals] = (cents / 100).toFixed(2).split('.');
  const group = (separator) => whole.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  const rounded = (separator) => String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  const values = {
    amount: `${group(',')}.${decimals}`,
    amount_no_decimals: rounded(','),
    amount_with_comma_separator: `${group('.')},${decimals}`,
    amount_no_decimals_with_comma_separator: rounded('.'),
    amount_with_apostrophe_separator: `${group("'")}.${decimals}`,
  };
  return format.replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => values[key] || values.amount);
}

class ProductForm extends HTMLElement {
  connectedCallback() {
    this.quantity = this.querySelector('input[name="quantity"]');
    this.total = this.querySelector('[data-total]');

    this.addEventListener('click', (event) => {
      const step = event.target.closest('[data-qty]');
      if (!step) return;
      if (step.dataset.qty === '1') this.quantity.stepUp();
      else this.quantity.stepDown();
      this.update();
    });

    this.addEventListener('change', (event) => {
      if (event.target.name === 'id') {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', event.target.value);
        window.history.replaceState({}, '', url);
      }
      this.update();
    });

    this.addEventListener('input', () => this.update());
  }

  update() {
    const chosen = this.querySelector('input[name="id"]:checked, input[name="id"][type="hidden"]');
    if (!chosen || !this.total) return;
    const quantity = Math.max(1, parseInt(this.quantity.value, 10) || 1);
    this.total.textContent = formatMoney(Number(chosen.dataset.price) * quantity, this.dataset.moneyFormat);
  }
}

if (!customElements.get('product-form')) customElements.define('product-form', ProductForm);

/** Thumbnails swap the visible image in the gallery. */
document.addEventListener('click', (event) => {
  const thumb = event.target.closest('[data-thumb]');
  if (!thumb) return;
  const media = thumb.closest('.product__media');
  media.querySelectorAll('[data-image-id]').forEach((image) => {
    image.hidden = image.dataset.imageId !== thumb.dataset.thumb;
  });
  media.querySelectorAll('[data-thumb]').forEach((button) => {
    button.setAttribute('aria-pressed', String(button === thumb));
  });
});
